import { TextButton } from '@wix/design-system';
import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { MobileStatusBox } from './MobileStatusBox';
export const MobilePrimaryDomainNotRegistered = _ref => {
  let domainName = _ref.domainName,
    action = _ref.action,
    datahook = _ref.datahook;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    Trans = _DomainSearchGateModu.Trans;
  const parsedDomain = parseDomain(domainName ?? '');
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.mobile.error.subdomain",
    values: {
      domainName: parsedDomain.main
    },
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      underline: "always",
      onClick: action
    })]
  }));
};
//# sourceMappingURL=MobilePrimaryDomainNotRegistered.js.map